export default __webpack_public_path__ + "static/media/LO14.14dd4991.mp3";